import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ToastService} from './toast.service';
import {IToast} from './interface';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {
  toasts: IToast[] = [];
  constructor(
    private toastService: ToastService,
  ) {
    this.toastService.toast.subscribe((item) => {
      const toast = {
        ...item,
        id: Math.random(),
      };
      this.toasts.push(toast);
      if (toast.autoHideMs && toast.autoHideMs > 0) {
        setTimeout(() => this.close(toast), toast.autoHideMs);
      }
    });
  }

  close(toast: IToast) {
    this.toasts = this.toasts.filter((item) => item.id !== toast.id);
  }

  open(toast: IToast) {
    toast.onClick?.();
    if (toast.onClick) {
      this.close(toast);
    }
  }
}
